import { SVGProps } from 'react'

export const ArrowLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity="0.3"
      d="M11.998 5.95216V5.95116C11.998 5.49111 11.6251 5.11816 11.165 5.11816L1.16405 5.11816C0.703994 5.11816 0.331047 5.49111 0.331047 5.95116V5.95216C0.331047 6.41222 0.703994 6.78516 1.16405 6.78516L11.165 6.78516C11.6251 6.78516 11.998 6.41222 11.998 5.95216Z"
      fill="#455570"
    />
    <path
      d="M6.75372 1.53986C6.91007 1.38365 6.99795 1.17173 6.99805 0.950718C6.99814 0.729707 6.91043 0.51771 6.75422 0.361364C6.59801 0.205019 6.38609 0.117133 6.16508 0.11704C5.94406 0.116946 5.73207 0.204652 5.57572 0.360865L0.575722 5.36087C0.423908 5.51266 0.336562 5.71721 0.331904 5.93185C0.327247 6.14648 0.405636 6.35463 0.550721 6.51287L5.13372 11.5129C5.20759 11.5937 5.29666 11.6592 5.39583 11.7056C5.49501 11.752 5.60236 11.7784 5.71175 11.7833C5.82113 11.7883 5.93042 11.7716 6.03336 11.7343C6.13631 11.697 6.23089 11.6397 6.31172 11.5659C6.39255 11.492 6.45804 11.4029 6.50444 11.3038C6.55085 11.2046 6.57727 11.0972 6.58219 10.9878C6.58711 10.8785 6.57044 10.7692 6.53313 10.6662C6.49581 10.5633 6.43859 10.4687 6.36472 10.3879L2.32072 5.97586L6.75372 1.53986Z"
      fill="#455570"
    />
  </svg>
)
